export default class PersianDate extends Date {
  constructor(...args) {
      super(...args);
  }

  toLocaleDateString = () => super.toLocaleDateString('fa-IR-u-nu-latn');
  getParts = () => this.toLocaleDateString().split("/")
  getDay = () => super.getDay() === 6 ? 0 : super.getDay() + 1
  getDate = () => this.getParts()[2];
  getMonth = () => this.getParts()[1];
  getYear = () => this.getParts()[0];
  getMonthName = () => super.toLocaleDateString('fa-IR-u-nu-latn', { month: 'long' });
  getDayName = () => super.toLocaleDateString("fa-IR-u-nu-latn", { weekday: 'long' });
  getFullDate = () => `${this.getDate()} ${this.getMonthName()} ${this.getYear()}`;
}